<template>
    <div v-if="projects && projects.length > 0">
        <div v-for="(project, i) in projects" :key="project.projectSno" class="invoice-project-view">
            <div class="project-header">
                <div>
                    <div class="name">{{ project.nam }}</div>
                    <div class="category">{{ project.pjcaT_NAM }}</div>
                </div>
                <div>
                    <span class="project-poo" :class="{ interactive: openableList[i] }" @click="onShowDetail(project.projectSno, !openableList[i])"> {{ project.poo }} </span>
                </div>
            </div>
            <div class="project-installments">
                <div v-for="installment in project.installments" :key="'installment-' + installment.sno">
                    <div class="project-installment-item">
                        <div class="sts-text">第 {{ installment.stG_NO }} 期</div>
                        <div class="price">
                            <Money :v="installment.amt" style="margin-right: 13px" />
                            <span class="cny">{{ installment.cny }}</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        projects: {
            type: Array,
            default: () => [],
        },
    },
    watch: {
        async projects(newVal) {
            this.openableList = [];
            await this.onFetchProjectDetailOpenable(newVal);
        },
    },
    data() {
        return {
            expend: true,
            openableList: [],
        };
    },
    computed: {
        openableProjects() {
            return this.projects.filter((pj) => pj.isOpenable);
        },
    },
    methods: {
        onShowDetail(projectSno, disabled) {
            if (!disabled) {
                this.$emit('show', projectSno);
            }
        },
        async onFetchProjectDetailOpenable(newVal) {
            // 確認專案是否可發送
            // eslint-disable-next-line no-restricted-syntax
            for (const pj of newVal) {
                try {
                    // eslint-disable-next-line no-await-in-loop
                    await this.$api_silent({
                        url: `ProjectManagementPage/GetProjectDetail?Sno=${pj.projectSno}`,
                        data: null,
                        method: 'GET',
                    });
                    this.openableList.push(true);
                } catch (err) {
                    this.openableList.push(false);
                }
            }
        },
    },
};
</script>

<style lang="scss" scoped>
@import "@/assets/scss/vars.scss";

.invoice-project-view {
    margin-top: 5px;
    background-color: #f4f4f7;
    border-radius: 10px;
    padding: 15px 25px 10px 25px;

    .interactive {
        cursor: pointer;
        color: $main-color;
        width: fit-content;
    }
    .project-header {
        display: flex;
        justify-content: space-between;

        .name {
            font-size: 11.5pt;
            font-weight: bold;
        }

        .category {
            color: #444;
        }
    }
    .project-installments {
        margin-top: 13px;

        .project-installment-item {
            display: flex;
            justify-content: space-between;
            border-top: 1px solid #ddd;
            padding: 5px 0;
        }
    }
}
</style>
